import { isPlatformBrowser } from '@angular/common';
import { APP_INITIALIZER, LOCALE_ID, PLATFORM_ID } from '@angular/core';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { InitOptions } from 'i18next';
import HttpApi from 'i18next-http-backend';
import { StorageService } from 'src/app/common/storage/storage.service';
import { LanguageDetector } from './i18n.utils';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
export const getConfig = (platformId: NonNullable<unknown>, sharryFavouriteLanguage?: string): InitOptions => ({
  load: 'languageOnly',
  ns: ['translations'],
  defaultNS: 'translations',
  debug: false,
  fallbackLng: 'it',
  preload: ['it', 'en', 'es', 'fr', 'de'],
  supportedLngs: ['it', 'en', 'es', 'fr', 'de'],
  detection: {
    sharryFavouriteLanguage,
    isBrowser: isPlatformBrowser(platformId),
    convertDetectedLanguage: (lng: string) => lng.split('-', 2)[0],
  },
  backend: {
    loadPath: `https://media.sharry.land/app/translations/{{lng}}.json?v=${Math.random()}`,
  },
  interpolation: {
    escapeValue: false,
  },
});
const appInit =
  (i18next: ITranslationService, platformId: NonNullable<unknown>, storageService: StorageService) => async () => {
    const sharryFavouriteLanguage = (await storageService.get('sharryFavouriteLanguage')) || 'it';
    let appLanguage: string;
    if (Capacitor.isNativePlatform()) {
      const appLang = await Device.getLanguageCode();
      appLanguage = ['it', 'en', 'es', 'fr', 'de'].includes(appLang.value) ? appLang.value : 'it';
    }
    const detector = new LanguageDetector(undefined, {
      isBrowser: isPlatformBrowser(platformId),
      convertDetectedLanguage: lng => lng.split('-', 2)[0],
      sharryFavouriteLanguage,
      appLanguage,
    });
    i18next.use(HttpApi).use(detector);
    if (!i18next.isInitialized) {
      await i18next.init({ ...getConfig(platformId, sharryFavouriteLanguage) });
    }
    return i18next;
  };

const localeIdFactory = (i18next: ITranslationService) => i18next.language;

export const I18N_PROVIDERS = [
  {
    provide: APP_INITIALIZER,
    useFactory: appInit,
    deps: [I18NEXT_SERVICE, PLATFORM_ID, StorageService],
    multi: true,
  },
  {
    provide: LOCALE_ID,
    deps: [I18NEXT_SERVICE],
    useFactory: localeIdFactory,
  },
];
